import { render, staticRenderFns } from "./GLDeptHelpList.vue?vue&type=template&id=2358cbe4&"
import script from "./GLDeptHelpList.vue?vue&type=script&lang=js&"
export * from "./GLDeptHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports